
/*
           this.actionTypes = [
            'TICKET_CREATE',
            'TICKET_FETCH',
            'TICKET_JOIN', 
            'TICKET_APPROVE',
            'TICKET_RATE'
          ];
*/
export const TICKET_CREATE     = 'TICKET_CREATE';
export const TICKET_FETCH      = 'TICKET_FETCH'; 
export const TICKET_JOIN       = 'TICKET_JOINT'; 
export const TICKET_UPDATE     = 'TICKET_UPDATE'; 

// export const TICKET_RATE       = 'TICKET_RATE'; 

export const TICKET_LOGIN      = 'TICKET_LOGIN'; 